/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteOnboardingRequest
 */
export interface CompleteOnboardingRequest {
    /**
     * Medical license number
     * @type {string}
     * @memberof CompleteOnboardingRequest
     */
    licenseNumber?: string;
    /**
     * Medical specialties
     * @type {Array<string>}
     * @memberof CompleteOnboardingRequest
     */
    specialties?: Array<string>;
    /**
     * Practice ID
     * @type {string}
     * @memberof CompleteOnboardingRequest
     */
    practiceId?: string;
}

/**
 * Check if a given object implements the CompleteOnboardingRequest interface.
 */
export function instanceOfCompleteOnboardingRequest(value: object): value is CompleteOnboardingRequest {
    return true;
}

export function CompleteOnboardingRequestFromJSON(json: any): CompleteOnboardingRequest {
    return CompleteOnboardingRequestFromJSONTyped(json, false);
}

export function CompleteOnboardingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteOnboardingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'licenseNumber': json['licenseNumber'] == null ? undefined : json['licenseNumber'],
        'specialties': json['specialties'] == null ? undefined : json['specialties'],
        'practiceId': json['practiceId'] == null ? undefined : json['practiceId'],
    };
}

export function CompleteOnboardingRequestToJSON(json: any): CompleteOnboardingRequest {
    return CompleteOnboardingRequestToJSONTyped(json, false);
}

export function CompleteOnboardingRequestToJSONTyped(value?: CompleteOnboardingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'licenseNumber': value['licenseNumber'],
        'specialties': value['specialties'],
        'practiceId': value['practiceId'],
    };
}

